import { render, staticRenderFns } from "./UnderwayOrder.vue?vue&type=template&id=1bbe7d00&scoped=true"
import script from "./UnderwayOrder.vue?vue&type=script&lang=js"
export * from "./UnderwayOrder.vue?vue&type=script&lang=js"
import style0 from "./UnderwayOrder.vue?vue&type=style&index=0&id=1bbe7d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe7d00",
  null
  
)

export default component.exports